import { render, staticRenderFns } from "./Punish.vue?vue&type=template&id=cd5f4940&scoped=true"
import script from "./Punish.vue?vue&type=script&lang=js"
export * from "./Punish.vue?vue&type=script&lang=js"
import style0 from "./Punish.vue?vue&type=style&index=0&id=cd5f4940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f4940",
  null
  
)

export default component.exports